if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      
        onVariantChangeUnsubscriber = undefined;
        abortController = undefined;
        pendingRequestUrl = null;
        preProcessHtmlCallbacks = [];
        postProcessHtmlCallbacks = [];

        constructor() {
            super();
            this.init();
            this.addIdToRecentlyViewed(this);
            
        }

        connectedCallback() {
            /* this.initializeProductSwapUtility(); */

            this.onVariantChangeUnsubscriber = subscribe(
                PUB_SUB_EVENTS.optionValueSelectionChange,
                this.handleOptionValueChange.bind(this)
            );

            this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
        }

        init(){
            
            const html = document.querySelector('html');

            const variant = this.getSelectedVariant(html);

            
            this.updateMedia(html, variant?.featured_media?.id);

        }


        addPreProcessCallback(callback) {
            this.preProcessHtmlCallbacks.push(callback);
        }

        disconnectedCallback() {
            this.onVariantChangeUnsubscriber();
        }

        /* initializeProductSwapUtility() {
            this.preProcessHtmlCallbacks.push((html) =>
            html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
            );
            this.postProcessHtmlCallbacks.push((newNode) => {
            window?.Shopify?.PaymentButton?.init();
            window?.ProductModel?.loadShopifyXR();
            });
        } */

        handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {

            
            if (!this.contains(event.target)) return;

            //this.resetProductFormState();
            
            const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;

            
            this.pendingRequestUrl = productUrl;
            const shouldSwapProduct = this.dataset.url !== productUrl;
            const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

            
            
            this.renderProductInfo({
            requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
            targetId: target.id,
            callback: shouldSwapProduct
                ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
                : this.handleUpdateProductInfo(productUrl),
            });
        }

        /* resetProductFormState() {
            const productForm = this.productForm;
            
            productForm?.toggleSubmitButton(true);
            productForm?.handleErrorMessage();
        } */

        handleSwapProduct(productUrl, updateFullPage) {
            return (html) => {
            this.productModal?.remove();

            const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
            const variant = this.getSelectedVariant(html.querySelector(selector));
            this.updateURL(productUrl, variant?.id);

            if (updateFullPage) {
                document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

                HTMLUpdateUtility.viewTransition(
                document.querySelector('main'),
                html.querySelector('main'),
                this.preProcessHtmlCallbacks,
                this.postProcessHtmlCallbacks
                );
            } else {
                HTMLUpdateUtility.viewTransition(
                this,
                html.querySelector('product-info'),
                this.preProcessHtmlCallbacks,
                this.postProcessHtmlCallbacks
                );
            }
            };
        }

        renderProductInfo({ requestUrl, targetId, callback }) {            

            this.abortController?.abort();
            this.abortController = new AbortController();

            fetch(requestUrl, { signal: this.abortController.signal })
            .then((response) => response.text())
            .then((responseText) => {
                this.pendingRequestUrl = null;
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                callback(html);
            })
            .then(() => {
                // set focus to last clicked option value                
                document.querySelector(`#${targetId}`)?.focus();
            })
            .catch((error) => {
                if (error.name === 'AbortError') {
                console.log('Fetch aborted by user');
                } else {
                console.error(error);
                }
            });
        }

        getSelectedVariant(productInfoNode) {

            const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;

            return !!selectedVariant ? JSON.parse(selectedVariant) : null;
        }

        buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
            const params = [];

            !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);



            if (optionValues.length) {
            params.push(`option_values=${optionValues.join(',')}`);
            }

        // console.log(`${url}?${params.join('&')}`);
            

            return `${url}?${params.join('&')}`;
        }

        updateOptionValues(html) {
            const variantSelects = html.querySelector('variant-selects');
            
            if (variantSelects) {
            HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
            
            }
        }
        toggleAddButton(disable = true, text, modifyClass = true) {
            const productForm = document.getElementById(`product-form-${this.dataset.section}`);
            if (!productForm) return;
            const addButton = productForm.querySelector('[name="add"]');
            const buttonsContainer = productForm.querySelector(".shopiy-payment-buttons-container");
            const payButton = buttonsContainer.querySelector('[data-shopify="payment-button"]');
            const payButtons = payButton && payButton.querySelectorAll("button");
            const addButtonText = addButton.querySelector('[name="add"] .add-to-cart-content');

            if (!addButton) return;
            if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            buttonsContainer.classList.add('hidden');
            payButton && payButton.classList.add('hidden');
            if (text) addButtonText.textContent = text;
            } else {
            addButton.removeAttribute('disabled');
            buttonsContainer.classList.remove('hidden');
            payButton && payButton.classList.remove('hidden');
            addButtonText.textContent = window.variantStrings.addToCart;
            }

            if (!modifyClass) return;
        }

        updateInventory(html) {
            const id = `stock-inventory-${this.dataset.section}`;
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
        
            if (source && destination) destination.innerHTML = source.innerHTML;
        }

        handleUpdateProductInfo(productUrl) {

            return (html) => {

            
            const variant = this.getSelectedVariant(html);

            
            

            this.pickupAvailability?.update(variant);
            this.updateOptionValues(html);

            this.updateURL(productUrl, variant?.id);
            this.updateVariantInputs(variant?.id);

            if (!variant) {
                this.setUnavailable();
                return;
            }

            

            this.updateMedia(html, variant?.featured_media?.id);

            const destination = document.getElementById(`price-${this.dataset.section}`);
            const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
            if (source && destination) destination.innerHTML = source.innerHTML;
            const price = document.getElementById(`price-${this.dataset.section}`);
            const inventory = document.getElementById(`stock-inventory-${this.dataset.section}`);
            const buttons = document.getElementById(`buy-buttons-${ this.dataset.section }`);
            const variant_picker = document.getElementById(`variant-picker-${ this.dataset.section }`);
            const options = variant_picker.querySelectorAll('.option_selected_value');
            const payButton = document.querySelectorAll('[data-shopify="payment-button"]');
                if (inventory) inventory.classList.remove('visibility-hidden'), this.updateInventory(html);
                
                options.length > 0 && options.forEach(ele=> {
                if(variant){
                    const selected = variant[ele.getAttribute('data-option')];
                    if(selected && selected.includes(":#")){
                        ele.textContent = selected.split(":")[0]; 
                    }else{
                        ele.textContent = selected;
                    }
                }
                })
                if (price) price.classList.remove('visibility-hidden');
                this.toggleAddButton(!variant || !variant.available, window.variantStrings.soldOut);
                publish(PUB_SUB_EVENTS.variantChange, {data: {
                sectionId: this.sectionId,
                html,
                variant: variant
                }});
            };
        }

        updateVariantInputs(variantId) {
            this.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
            ).forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            const errorMessage = productForm.querySelector('#product_form-error');
            if(errorMessage && !errorMessage.classList.contains("hidden")) errorMessage.classList.add('hidden')
            input.value = variantId ?? '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
            });
                
        }

        getCdnPath(url) {
            // Extract the /cdn/... path
            const match = url.match(/\/cdn\/[^\?#]*/);
            return match ? match[0] : url;
        }


        compareImages(url1, url2) {
                return this.getCdnPath(url1).split('?')[0] === this.getCdnPath(url2).split('?')[0];
        }

        updateURL(url, variantId) {
            this.querySelector('share-button')?.updateUrl(
            `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
            );
            if (this.dataset.updateUrl === 'false') return;
            window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
        }

        setUnavailable() {
            const button = document.getElementById(`product-form-${this.dataset.section}`);
            const inventory = document.getElementById(`stock-inventory-${this.dataset.section}`);
            const addButton = button.querySelector('[name="add"]');
            
            const addButtonText = addButton.querySelector('[name="add"] .add-to-cart-content');
            const price = document.getElementById(`price-${this.dataset.section}`);
            if (!addButton) return;
            addButtonText.textContent = window.variantStrings.unavailable;
            
            if (price) price.classList.add('visibility-hidden');
            if (!inventory) return;
            inventory.classList.add('visibility-hidden');
        }

        updateMedia(html, variantFeaturedMediaId) {
            

        if (!variantFeaturedMediaId) return;

        
        const mediaGallerySource = this.querySelector('media-gallery #images-slider');
        const slider_layout = mediaGallerySource.getAttribute("data-desktop-type") === "slider";     
        
        const variant = this.getSelectedVariant(html).featured_media.preview_image.src;   


        
        const selected_element = [...mediaGallerySource.children].find((slide)=>{
            const slide_img = slide.querySelector("img");
            if(!slide_img) return;
            return this.compareImages(slide_img.src, variant);
        });    
        

        
        if (!selected_element) return;        
        
        selected_element.setAttribute('data-selected', true);
        
        if (slider_layout || window.innerWidth < 850) {
            const slider_x_start = mediaGallerySource.getBoundingClientRect().left;
            const selected_x = selected_element.getBoundingClientRect().left;
            const offset = selected_x - slider_x_start;
        
            mediaGallerySource.scrollTo({
            left: mediaGallerySource.scrollLeft + offset,
            behavior: 'auto' // 'auto' or remove this line if 'instant' doesn't work well
            });
        } else {
            const element_rect = selected_element.getBoundingClientRect();
            const scroll_target = window.scrollY + element_rect.top - (window.innerHeight / 2) + (element_rect.height / 2);
        
            window.scrollTo({
            top: scroll_target,
            behavior: "smooth"
            });
        }
        }

        addIdToRecentlyViewed(container) {
          const slug = container.getAttribute('data-product-slug');
          const link = container.getAttribute('data-url');
          const image = container.getAttribute('data-product-image');

          // Get recently viewed products from local storage (if available)
          let recentlyViewed = JSON.parse(localStorage.getItem('products-recently-viewed')) || {};

          // Remove the current product if already in the list
          if (recentlyViewed.hasOwnProperty(slug)) {
            delete recentlyViewed[slug];
          }

          // Add it back to the list
          recentlyViewed[slug] = {
            link,
            image
          };

          // Store the updated recently viewed products in local storage
          localStorage.setItem('products-recently-viewed', JSON.stringify(recentlyViewed));
        
        }

        get productForm() {
            return this.querySelector(`product-form`);
        }

        get productModal() {
            return document.querySelector(`#ProductModal-${this.dataset.section}`);
        }

        get pickupAvailability() {
            return this.querySelector(`pickup-availability`);
        }

        get variantSelectors() {
            return this.querySelector('variant-selects');
        }

        get relatedProducts() {
            const relatedProductsSectionId = SectionId.getIdForSection(
            SectionId.parseId(this.sectionId),
            'related-products'
            );
            return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
        }

        get quickOrderList() {
            const quickOrderListSectionId = SectionId.getIdForSection(
            SectionId.parseId(this.sectionId),
            'quick_order_list'
            );
            return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
        }

        get sectionId() {
            return this.dataset.originalSection || this.dataset.section;
        }
    }
  );
}

